<div class="modal-header">
  <h4 class="modal-title">Rate And Reviews - {{RNRModel.BusinessName}}</h4>
  <a href="javascript:void(0)" style="color: black;" data-dismiss="modal">
    <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>
<div class="modal-body">
    <div class="form-group">
      <h5>{{RNRModel.OverallRatingText}}</h5>
      <h5>{{RNRModel.StarHeaderText}}</h5>
      <img [src]="RNRModel.StarImageUrl" height="50px" width="50px" id="starImageUrl" [hidden]="!RNRModel.StarImageUrl">
      <h5>{{RNRModel.StarText}}</h5>
      <div class="row">
        <div class="col-md-6">
          <fieldset class="rating">
            <input type="radio" id="star5" name="rating" value="5" (click)="BindRatingImageOnSelect(5)"><label class="full" for="star5" title="Awesome - 5 stars"></label>
            <input type="radio" id="star4" name="rating" value="4" (click)="BindRatingImageOnSelect(4)"><label class="full" for="star4" title="Pretty good - 4 stars"></label>
            <input type="radio" id="star3" name="rating" value="3" (click)="BindRatingImageOnSelect(3)"><label class="full" for="star3" title="Mediocre - 3 stars"></label>
            <input type="radio" id="star2" name="rating" value="2" (click)="BindRatingImageOnSelect(2)"><label class="full" for="star2" title="Kinda bad - 2 stars"></label>
            <input type="radio" id="star1" name="rating" value="1" (click)="BindRatingImageOnSelect(1)"><label class="full" for="star1" title="Bad - 1 star"></label>
          </fieldset>
        </div>
        <div class="col-md-6" *ngIf="BranchList.length > 1">
          <div class="form-group">
            <select class="form-control" [(ngModel)]="RNRModel.BusinessBranchID">
              <option [value]="item.BusinessBranchID" *ngFor="let item of BranchList">{{item.BranchName}}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12">
          <ul class="lst_checkBox">
            <li *ngFor="let item of RateAndReviewList">
              <span>{{item.RatingParameter}}</span>
              <input type="checkbox" (click)="OnRatingOptionClick(item.RatingParamID, $event.target)" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="MB15 col-sm-12">
        <h5>Review</h5>
        <textarea class="form-control" [(ngModel)]="RNRModel.UserReviewText"
                  [ngModelOptions]="{standalone: true}"></textarea>
      </div>
    </div>
    <!-- <div class="row" *ngIf="UserLoggedIn">
      <div class="col-md-12">
        <div id="rNrForm" class="cManikgreCaptcha"></div>
        <span *ngIf="CaptchaInvalid" class="text-danger">
          <span> {{CaptchaMessage}}</span>
        </span>
      </div>
    </div> -->
    <div class="row" >
      <div class="col-md-12">
        <label id="lbl2RMessage" style="display: none;" class="alert alert-info"></label>
        <button type="submit" class="btn btn-primary" (click)="SubmitForm();"
                *ngIf="!RNRModel.SubmittedRNR">
          Submit
        </button>
        <button class="btn btn-primary" *ngIf="RNRModel.SubmittedRNR">
          <manik-button-loader></manik-button-loader>
        </button>
        <button type="button" id="btnClose" class="btn btn-danger" *ngIf="!RNRModel.SubmittedRNR" data-dismiss="modal">Close</button>
      </div>
    </div>
    <!--  <app-visitor-handler *ngIf="!UserLoggedIn" [CountryID]="WebSiteMetaData.COUNTRYID" [PortalName]="WebSiteMetaData.PC" [PortalID]="WebSiteMetaData.PID" (visitorLoggedIn)="CheckUserLoggedIn();Emit();"></app-visitor-handler> -->
 
</div>


